import { render, staticRenderFns, recyclableRender, components } from "./add_subtract_insurance.vue?vue&type=template&id=51b24d26&scoped=true&"
var renderjs
import script from "./add_subtract_insurance.vue?vue&type=script&lang=js&"
export * from "./add_subtract_insurance.vue?vue&type=script&lang=js&"
import style0 from "./add_subtract_insurance.vue?vue&type=style&index=0&lang=css&"
import style1 from "./add_subtract_insurance.vue?vue&type=style&index=1&id=51b24d26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b24d26",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/add_subtract_insurance/add_subtract_insurance.vue"
export default component.exports